import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { danThuocApi } from "../../../api/y-te/danThuocApi";
import { danThuocChiTietApi } from "../../../api/y-te/danThuocChiTietApi";
import { danThuocHinhAnhApi } from "../../../api/y-te/danThuocHinhAnhApi";
import { IBaseResponeModel } from "../../../models/response/base-response";
import {
	eDanThuocActionTypeIds,
	IDanThuocCapNhatXuLyStart,
	IDanThuocDeleteChiTietStart,
	IDanThuocDeleteStart,
	IDanThuocLoadChiTietStart,
	IDanThuocLoadDetailStart,
	IDanThuocLoadHinhAnhStart,
	IDanThuocLoadStart,
	IDanThuocSaveChiTietStart,
	IDanThuocSaveStart
} from "../../action-types/y-te/IDanThuocActionTypes";
import { danThuocActions } from "../../actions/y-te/danThuocActions";

export function* danThuocSaga(): any {
	yield takeLatest(eDanThuocActionTypeIds.LOAD_START, loadDanThuocWorker)
	yield takeLatest(eDanThuocActionTypeIds.LOAD_DETAIL_START, loadDanThuocDetailWorker)
	yield takeLatest(eDanThuocActionTypeIds.LOAD_CHITIET_START, loadDanThuocChiTietWorker)
	yield takeLatest(eDanThuocActionTypeIds.LOAD_HINHANH_START, loadDanThuocHinhAnhWorker)
	yield takeEvery(eDanThuocActionTypeIds.SAVE_START, saveDanThuocWorker)
	yield takeEvery(eDanThuocActionTypeIds.DELETE_START, deleteDanThuocWorker)
	yield takeEvery(eDanThuocActionTypeIds.CAPNHAT_XULY_START, capNhatXuLyDanThuocWorker)
	yield takeEvery(eDanThuocActionTypeIds.SAVE_CHITIET_START, saveDanThuocChiTietWorker)
	yield takeEvery(eDanThuocActionTypeIds.DELETE_CHITIET_START, deleteDanThuocChiTietWorker)
}

function* loadDanThuocWorker(action: IDanThuocLoadStart): any {
	const res: IBaseResponeModel = yield call([danThuocApi, danThuocApi.SelectAllByCoSo], action.payload)
	if (res.is_success) {
		yield put(danThuocActions.loadDanThuocSuccess(res.data || []))
	} else {
		yield put(danThuocActions.loadDanThuocError(res.message || "Không tải được danh sách đơn thuốc"))
	}
}

function* loadDanThuocDetailWorker(action: IDanThuocLoadDetailStart): any {
	const res: IBaseResponeModel = yield call([danThuocApi, danThuocApi.SelectById], action.payload)
	if (res.is_success) {
		if (res.data) {
			yield put(danThuocActions.loadDanThuocDetailSuccess(res.data))
		}
	} else {
		yield put(danThuocActions.loadDanThuocDetailError(res.message || "Không tải được chi tiết đơn thuốc"))
	}
}

function* saveDanThuocWorker(action: IDanThuocSaveStart): any {
	let res: IBaseResponeModel;
	const is_update = action.payload.id > 0;
	if (is_update) {
		res = yield call([danThuocApi, danThuocApi.Update], action.payload);
	} else {
		res = yield call([danThuocApi, danThuocApi.Insert], action.payload);
	}
	if (res.is_success) {
		yield put(danThuocActions.saveDanThuocSuccess(is_update))
	} else {
		yield put(danThuocActions.saveDanThuocError(res.message || "Không lưu được đơn thuốc"))
	}
}

function* deleteDanThuocWorker(action: IDanThuocDeleteStart): any {
	const res: IBaseResponeModel = yield call([danThuocApi, danThuocApi.Delete], action.payload)
	if (res.is_success) {
		yield put(danThuocActions.deleteDanThuocSuccess())
	} else {
		yield put(danThuocActions.deleteDanThuocError(res.message || "Không xoá được đơn thuốc"))
	}
}

function* capNhatXuLyDanThuocWorker(action: IDanThuocCapNhatXuLyStart): any {
	const { ids, da_xu_ly } = action.payload;
	let res: IBaseResponeModel;
	if (da_xu_ly) {
		res = yield call([danThuocApi, danThuocApi.CapNhatXuLy], ids);
	} else {
		res = yield call([danThuocApi, danThuocApi.CapNhatChuaXuLy], ids);
	}
	if (res.is_success) {
		yield put(danThuocActions.capNhatXuLyDanThuocSuccess())
	} else {
		yield put(danThuocActions.capNhatXuLyDanThuocError(res.message || "Không cập nhật được trạng thái xử lý"))
	}
}

function* loadDanThuocChiTietWorker(action: IDanThuocLoadChiTietStart): any {
	const res: IBaseResponeModel = yield call([danThuocChiTietApi, danThuocChiTietApi.SelectByDanThuoc], action.payload)
	if (res.is_success) {
		yield put(danThuocActions.loadDanThuocChiTietSuccess(res.data || []))
	} else {
		yield put(danThuocActions.loadDanThuocChiTietError(res.message || "Không tải được danh sách đơn thuốc chi tiết"))
	}
}

function* saveDanThuocChiTietWorker(action: IDanThuocSaveChiTietStart): any {
	let res: IBaseResponeModel;
	const is_update = action.payload.id > 0;
	if (is_update) {
		res = yield call([danThuocChiTietApi, danThuocChiTietApi.Update], action.payload);
	} else {
		res = yield call([danThuocChiTietApi, danThuocChiTietApi.Insert], action.payload);
	}
	if (res.is_success) {
		yield put(danThuocActions.saveDanThuocChiTietSuccess(is_update))
	} else {
		yield put(danThuocActions.saveDanThuocChiTietError(res.message || "Không lưu được đơn thuốc chi tiết"))
	}
}

function* deleteDanThuocChiTietWorker(action: IDanThuocDeleteChiTietStart): any {
	const res: IBaseResponeModel = yield call([danThuocChiTietApi, danThuocChiTietApi.Delete], action.payload)
	if (res.is_success) {
		yield put(danThuocActions.deleteDanThuocChiTietSuccess())
	} else {
		yield put(danThuocActions.deleteDanThuocChiTietError(res.message || "Không xoá được đơn thuốc chi tiết"))
	}
}

function* loadDanThuocHinhAnhWorker(action: IDanThuocLoadHinhAnhStart): any {
	const res: IBaseResponeModel = yield call([danThuocHinhAnhApi, danThuocHinhAnhApi.SelectByDanThuoc], action.payload)
	if (res.is_success) {
		yield put(danThuocActions.loadDanThuocHinhAnhSuccess(res.data || []))
	} else {
		yield put(danThuocActions.loadDanThuocHinhAnhError(res.message || "Không tải được danh sách hình ảnh"))
	}
}
